import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
let StandardNotificationDialog = class StandardNotificationDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "toggleDialog", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "visible", false);
  }
  onDialogClose() {
    this.visible = false;
    this.$emit("dialogClose");
  }
};
__decorate([Prop({
  default: false
})], StandardNotificationDialog.prototype, "toggleDialog", void 0);
__decorate([Prop({
  default: ''
})], StandardNotificationDialog.prototype, "title", void 0);
StandardNotificationDialog = __decorate([Options({
  watch: {
    toggleDialog() {
      this.visible = this.toggleDialog;
    }
  }
})], StandardNotificationDialog);
export default StandardNotificationDialog;